import { buildQueryString } from '../../lib/query-params.ts';
import { apiClient } from '../client.ts';
import type {
  Deployment,
  DeploymentLog,
  DeploymentStats,
  CreateDeploymentParams,
  PaginatedResponse,
  DeploymentOverview,
  UpdateTriggersParams,
} from '../types.ts';

export async function listDeployments(params?: {
  page?: number;
  pageSize?: number;
  projectId?: string;
  serverId?: string;
  environmentId?: string;
  environmentName?: string;
  status?: string;
}): Promise<PaginatedResponse<Deployment>> {
  return apiClient.get<PaginatedResponse<Deployment>>(`/deployments${buildQueryString(params)}`);
}

export async function getDeployment(deploymentId: string): Promise<Deployment> {
  return apiClient.get<Deployment>(`/deployments/${deploymentId}`);
}

export async function createDeployment(params: CreateDeploymentParams): Promise<Deployment> {
  return apiClient.post<Deployment>('/deployments', params);
}

export async function getDeploymentLogs(deploymentId: string): Promise<DeploymentLog[]> {
  return apiClient.get<DeploymentLog[]>(`/deployments/${deploymentId}/logs`);
}

export async function cancelDeployment(deploymentId: string): Promise<Deployment> {
  return apiClient.post<Deployment>(`/deployments/${deploymentId}/cancel`);
}

export async function rollbackDeployment(deploymentId: string): Promise<Deployment> {
  return apiClient.post<Deployment>(`/deployments/${deploymentId}/rollback`);
}

export async function retryDeployment(deploymentId: string): Promise<Deployment> {
  return apiClient.post<Deployment>(`/deployments/${deploymentId}/retry`);
}

export async function getDeploymentStats(params?: {
  projectId?: string;
}): Promise<DeploymentStats> {
  return apiClient.get<DeploymentStats>(`/deployments/stats${buildQueryString(params)}`);
}

export async function getDeploymentOverview(): Promise<DeploymentOverview> {
  return apiClient.get<DeploymentOverview>('/deployments/overview');
}

export async function getEnvironmentRuns(envId: string, params?: {
  page?: number;
  pageSize?: number;
}): Promise<PaginatedResponse<Deployment>> {
  return apiClient.get<PaginatedResponse<Deployment>>(`/deployments/environments/${envId}/runs${buildQueryString(params)}`);
}

export async function updateEnvironmentTriggers(envId: string, params: UpdateTriggersParams) {
  return apiClient.put(`/deployments/environments/${envId}/triggers`, params);
}
